import {getDeclension} from "../../../lib/utils/helpers";
import React from "react";
import {IWeatherInfo} from "../../../lib/utils/types";
import {t} from "i18next";
import { normalizeTimePart } from "../../../lib/utils/format";

const WeatherInfo = ({airTemperature, waterTemperature, hoursSailing, hoursSailingLimit, startTime, isShowBookingTime}: IWeatherInfo) =>
    <div className="weather">
        {(airTemperature || waterTemperature) &&
            <div className="temperature">
                <div className="temperature__label card-label">{t('bookingCard.temperature')}</div>
                {airTemperature &&
                    <div className="temperature__value-air card-caption">
                        {t('bookingCard.air')} — {airTemperature}&deg;
                    </div>
                }
                {waterTemperature &&
                    <div className="temperature__value-water card-caption">
                        {t('bookingCard.water')} — {waterTemperature}&deg;
                    </div>
                }
            </div>
        }
        {hoursSailing && hoursSailingLimit &&
            <div className="time">
                <div className="time__label card-label">
                    {t('bookingCard.waterTime')}
                </div>
                <div className="time__value card-caption">
                    {`${t('bookingCard.from')} ${hoursSailing}
                    ${t('bookingCard.to')} ${hoursSailingLimit || hoursSailing}
                    ${t(getDeclension(+hoursSailingLimit))}`}
                </div>
            </div>
        }
        {isShowBookingTime &&
            <div className="start-time">
                <div className="card-label">
                    {t('bookingCard.startTime')}
                </div>
                <div className="card-caption">
                    {normalizeTimePart(startTime)}
                </div>
            </div>
        }
    </div>

export default WeatherInfo